import axios from 'axios';
var Vue = require('vue')

/**
 * Converts app language code (for example 'en', 'en-gb', 'sl') to a full locale ID.
 * Output is compatible with Angular, moment, date-fns, etc... ('en-US, 'en-GB', 'sl-SI').
 * Should be kept in sync with supported languages in angular.json & API.
 * @param language
 */
export function appLanguageToLocale(language) {
    const languageMap = {
        'en': 'en-US',
        'en-gb': 'en-GB',
        'sl': 'sl-SI',
        'de': 'de-DE',
        'hr': 'hr-HR',
        'zh': 'zh-CN',
        'it': 'it-IT',
        'fr': 'fr-FR',
        'es': 'es-ES',
        'nl': 'nl-NL',
    };
    if (!languageMap[language]) {
        console.warn(`Locale not found for language "${language}".`);
    }
    return languageMap[language];
}

export function getAcceptLanguage() {
    let x = window.location.hash.split('/')
    if (x[0] === '#') {
        x.shift()
    }
    return appLanguageToLocale(x[0]) || 'en-US';
}

export function getCookie(cookieName) {
    const name = cookieName + '=';
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
            return c.substring(name.length, c.length);
        }
    }
    return '';
}

export class SaleSquezeSdkBrowser {

    /**
     * Base URL of API (can be relative).
     * @example /v2
     * @example http://localhost:3100/v2'
     */
    apiBaseUrl = '/api/v3';

    /**
     * @type {string}
     */
    clientKey = '';

    /**
     * @type {string}
     */
    language = 'en';

    /**
     * View token.
     * @type {string}
     */
    viewToken;

    /**
     * Edit token.
     * @type {string}
     */
    editToken;

    static create() {
      console.log(Vue);
      return new SaleSquezeSdkBrowser({
        clientKey: process.env.clientKey || getCookie('client') || window.location.hostname.split('.')[0],
        language: appLanguageToLocale(getCookie('language') || 'en'),
        apiBaseUrl: process.env.apiBaseUrl
      });
    }

    /**
     * @param {string} options.clientKey
     * @param {string} options.language
     * @param {string} [options.apiBaseUrl]
     */
    constructor(options) {
        this.language = options.language;
        this.clientKey = options.clientKey;
        this.apiBaseUrl = options.apiBaseUrl || this.apiBaseUrl;

        console.log(`
%c======== SaleSqueze SDK initialized ========
  Language : ${ this.language }
  Client   : ${ this.clientKey }
  API      : ${ this.apiBaseUrl }
  SVC KEY  : ${ process.env.serviceKey }
  PARTNERS : ${ process.env.partnersUrl }
============================================`, "color:blue");
    }

    /**
     * @param {string} documentServiceType
     * @return {Promise<any>}
     */
    async createDocument(documentServiceType, document) {
        return axios.post(`${this.apiBaseUrl}/dynamic-form/${documentServiceType}/documents`, document, {
            headers: {
                'X-Client-Key': this.clientKey,
                'Accept-Language': getAcceptLanguage()
            }
        });
    }

    /**
     * @param {string[]} tags Tags to filter by.
     * @return {Promise<any>}
     */
    getProducts(filter, project) { // filter: : { tags?: string[], categories?: string[], key?: string }, project?: { [x: string]: number }
      return axios.get(`${ this.apiBaseUrl }/catalog/product/cpq/documents`, {
        headers: {
          'X-Client-Key': this.clientKey,
          'viewToken': this.viewToken,
          'editToken': this.editToken,
          'Accept-Language': getAcceptLanguage()
        },
        params: {
          pageSize: 999,
          sortBy: {
            path: '_createdAt',
            direction: -1
          },
          filter: {
            ...(filter.tags ? {
              tags: {
                type: 'type-string',
                value: filter.tags,
                options: {
                  exactMatch: true,
                  exclude: false,
                }
              }
            } : {}),
            ...(filter.categories ? {
              categoryKey: {
                type: 'type-string',
                value: filter.categories,
                options: {
                  exactMatch: true,
                  exclude: false,
                }
              }
            } : {}),
            ...(filter.key ? {
              key: {
                type: 'type-string',
                value: filter.key,
                options: {
                  exactMatch: true,
                  exclude: false,
                }
              }
            } : {}),
          },
          project: {
            configurableAddons: 1,
            ...project
          }
        }
      })
    }
}

export const salesqueze = SaleSquezeSdkBrowser.create();
